import fx from "../../utils/fx";
import AxiosInterceptor from "api/interceptor";

const account = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return account.get("/guard/accounts?" + qstr);
  },
  find(id) {
    return account.get("/guard/accounts/" + id);
  },
  create(inputs) {
    return account.post("/guard/accounts", inputs);
  },
  update(id, inputs) {
    return account.put("/guard/accounts/" + id, inputs);
  },
  delete(id) {
    return account.delete("/guard/accounts/" + id);
  },
  active(id, inputs) {
    return account.put("/guard/accounts/" + id + "/active", inputs);
  },
  getSearchAdmin(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return account.get("/guard/search?" + qstr);
  },
  getActivity(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return account.get("/guard/audit-logs?" + qstr);
  },
  resetPassword(data) {
    return account.put("/guard/reset-password", data);
  }
};
